import { useHistory } from 'react-router';
import { Button, Grid, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ArrowBack, ContentCopy } from "@mui/icons-material";
import { usePolicyStore } from '@store/policyStore';
import { useClamp } from '@utils/useClamp';

export function Return(){
    const history = useHistory();
    const { breakpoints, palette } = useTheme();
    const isMobile = useMediaQuery(breakpoints.up('xs'));
    const isTablet = useMediaQuery(breakpoints.up('sm'));
    const {policy, addPolicyInfo} = usePolicyStore();
    const {clamp} = useClamp();

    const copyToClipboard = () => {
        navigator.clipboard.writeText(policy.policyNumber)
    }
    const handleBtnClick = () => {
        let date = new Date();
      let day = `${date.getDate()}`.padStart(2, '0');
      let month = `${date.getMonth() + 1}`.padStart(2, '0');
      let year = date.getFullYear();
      let fechaHoy = `${year}-${month}-${day}`;
        addPolicyInfo({ ...policy, start_at: fechaHoy });
        history.push('/plans');
    };

    return (
        <Grid container style={{
            minHeight: clamp('88px', '88px', 'unset'),
            display: 'flex',
            alignContent: 'center',
            backgroundColor: '#FFF',
            padding: clamp('16px 150px', '0 40px', '16px 8px'),
            flexDirection: 'row'
        }}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Button
                    onClick={handleBtnClick}
                    variant={'text'}
                    startIcon={<ArrowBack fontSize="large" />}
                    style={{
                        color: palette.primary.main,
                        fontSize: '16px',
                        textTransform: 'none',
                        fontWeight: '600',
                    }}
                >
                    {isMobile && !isTablet ? "Regresar a mis opciones" : "Regresar"}
                </Button>
            </Grid>
            {isTablet && (
                <Grid item container xs={6} sm={6} md={6} lg={6} xl={6} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Typography style={{ fontWeight: '700', marginRight: '24px' }}>Número de cotización</Typography>
                    <Typography style={{ fontWeight: '400', marginRight: '16px', color: '#212121', fontStyle: 'italic' }}>{policy.policyNumber}</Typography>
                    <IconButton onClick={e => copyToClipboard()}>
                        <ContentCopy color="primary" fontSize='small' />
                    </IconButton>
                </Grid>
            )}

        </Grid>
    )
}